// test933
(933 && 0);
